import { z } from "zod";

const ALPHANUMERIC_REGEX_WITH_ACCENTS = /^[a-zA-Z0-9]+$/;
const ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS = "Solo se permiten caracteres alfanuméricos";

export const createSkuSchema = z.object({
    sku_number: z.string().min(1, { message: "Debes ingresar un ID" }).regex(ALPHANUMERIC_REGEX_WITH_ACCENTS, { message: ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS }),
    name: z.string().min(1, { message: "Debes ingresar un nombre" }),
    presentation: z.string().min(1, { message: "Debes seleccionar una presentación" }),
    brand: z.string().min(1, { message: "Debes seleccionar una marca" }),
    volume: z.string().min(1, { message: "Debes seleccionar un volumen" }),
    quantity: z.string().min(1, { message: "Debes seleccionar una cantidad" }),
    tipology: z.string().min(1, { message: "Debes seleccionar una tipología" }),
    size: z.string().min(1, { message: "Debes seleccionar un tamaño" }),
});

export const updateSkuSchema = z.object({
    sku_number: z.string().min(1, { message: "Debes ingresar un ID" }).regex(ALPHANUMERIC_REGEX_WITH_ACCENTS, { message: ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS }),
    name: z.string().min(1, { message: "Debes ingresar un nombre" }),
    presentation: z.string().min(1, { message: "Debes seleccionar una presentación" }),
    brand: z.string().min(1, { message: "Debes seleccionar una marca" }),
    volume: z.string().min(1, { message: "Debes seleccionar un volumen" }),
    quantity: z.string().min(1, { message: "Debes seleccionar una cantidad" }),
    tipology: z.string().min(1, { message: "Debes seleccionar una tipología" }),
    size: z.string().min(1, { message: "Debes seleccionar un tamaño" }),
    created_at: z.string().optional(),
});